import {Injectable} from '@angular/core';
import {accountManagementSettings, AccountOverrideSettings} from '@modules/authentication/core/config/account-management.settings';
import {AuthenticationOverrideSettings, authenticationSettings} from '@modules/authentication/core/config/authentication.settings';
import {get} from 'lodash-es';
import {ModelSchema} from 'octopus-model';
import {SwitchSettingsType} from 'shared/utils/settings';
import {modulesSettings} from '../../../../settings';

const settingsStructureAuth = new ModelSchema(authenticationSettings);
const settingsStructureAccount = new ModelSchema(accountManagementSettings);

type AuthenticationSettingsType = Omit<SwitchSettingsType<typeof authenticationSettings>, keyof AuthenticationOverrideSettings> & AuthenticationOverrideSettings;
type AccountSettingsType = Omit<SwitchSettingsType<typeof accountManagementSettings>, keyof AccountOverrideSettings> & AccountOverrideSettings;

@Injectable({
    providedIn: 'root'
})
export class AuthenticationConfigurationService {
    private authSettings =  settingsStructureAuth.filterModel(modulesSettings.authentication) as AuthenticationSettingsType;
    private accountSettings = settingsStructureAccount.filterModel(modulesSettings.accountManagement) as AccountSettingsType;
    public settings = {...this.authSettings, ...this.accountSettings};

    public get isLocalCacheEnabled(): boolean {
        return get(this.settings, 'enableLocalCache', false);
    }

    public get isSignupEnabled(): boolean {
        return get(this.settings, 'signup', true);
    }
    public get isSelfSignupEnabled(): boolean {
        return get(this.settings, 'selfSignup', true);
    }

    public get displayGARHelper(): boolean {
        return get(this.settings, 'displayGARHelper', true);
    }

    public get specificRedirectionPath(): string {
        return get(this.settings, 'specificRedirectionPath', null);
    }

    public get newsletterRulesAddNoSsoUser(): boolean {
        return get(this.settings, 'newsletterRulesAddNoSsoUser', false);
    }
}